import React, { Component, Fragment } from 'react';

import styles from './TerminalModal.css'
import {
    VERSION, BANNER_LINE1, BANNER_LINE2, MENU_ITEMS, WHOAMI_PARAGRAPHS,
    WORK_ROWS, RECS, DAGS, PROJECTS, POSTS, CONTACTS,
} from './terminalContent'

// DOM replica of the ssh TUI (apps/trapeznikov-ssh): same screens, same
// copy, same keybindings - but native browser mouse/selection/links. The
// real thing stays at ssh hi@trapeznikov.com.
class TerminalModal extends Component {
    state = { screen: 'menu', menuIdx: 0, projIdx: 0 };

    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (e.metaKey || e.ctrlKey || e.altKey) return;
        switch (e.key) {
            case 'q':
                this.props.onClose();
                break;
            case 'Escape':
                this.goBack();
                break;
            case 'ArrowUp':
            case 'k':
                e.preventDefault();
                this.moveCursor(-1);
                break;
            case 'ArrowDown':
            case 'j':
                e.preventDefault();
                this.moveCursor(1);
                break;
            case 'Enter':
            case 'ArrowRight':
            case 'l':
                this.selectItem();
                break;
            default:
                break;
        }
    };

    goBack = () => {
        const s = this.state.screen;
        if (s === 'menu') {
            this.props.onClose();
        } else if (s === 'detail') {
            this.setState({ screen: 'projects' });
        } else {
            this.setState({ screen: 'menu' });
        }
    };

    moveCursor(d) {
        const s = this.state.screen;
        if (s === 'menu') {
            const n = MENU_ITEMS.length;
            this.setState({ menuIdx: (this.state.menuIdx + d + n) % n });
        } else if (s === 'projects') {
            const n = PROJECTS.length;
            this.setState({ projIdx: (this.state.projIdx + d + n) % n });
        }
    }

    selectItem() {
        const s = this.state.screen;
        if (s === 'menu') {
            const id = MENU_ITEMS[this.state.menuIdx].id;
            if (id === 'exit') {
                this.props.onClose();
            } else if (id === 'projects') {
                this.setState({ screen: 'projects', projIdx: 0 });
            } else {
                this.setState({ screen: id });
            }
        } else if (s === 'projects') {
            this.setState({ screen: 'detail' });
        }
    }

    pickMenu = (i) => {
        this.setState({ menuIdx: i }, () => this.selectItem());
    };

    pickProject = (i) => {
        this.setState({ projIdx: i, screen: 'detail' });
    };

    hoverMenu = (i) => this.setState({ menuIdx: i });
    hoverProject = (i) => this.setState({ projIdx: i });

    render() {
        return (
            <div className={styles.overlay} onClick={this.props.onClose}>
                <div className={styles.window}
                     onClick={function (e) { e.stopPropagation(); }}>
                    <div className={styles.header}>
                        <span className={styles.cmd}>$ ssh hi@trapeznikov.com</span>
                        <span className={styles.hint}># q to close</span>
                        <button className={styles.close} type="button"
                                title="close" aria-label="close terminal"
                                onClick={this.props.onClose}>✕</button>
                    </div>
                    <div className={styles.body}>
                        {this.renderScreen()}
                        <div className={styles.hintline}>{this.hintText()}</div>
                    </div>
                </div>
            </div>
        )
    }

    hintText() {
        switch (this.state.screen) {
            case 'menu':
                return '↑↓ or mouse · enter select · q quit';
            case 'projects':
                return '↑↓ or mouse · enter open · esc back · q quit';
            default:
                return 'esc back · q quit';
        }
    }

    renderScreen() {
        switch (this.state.screen) {
            case 'menu':     return this.renderMenu();
            case 'whoami':   return this.renderWhoami();
            case 'work':     return this.renderWork();
            case 'projects': return this.renderProjects();
            case 'detail':   return this.renderDetail();
            case 'posts':    return this.renderPosts();
            case 'contact':  return this.renderContact();
            default:         return null;
        }
    }

    renderMenu() {
        var self = this;
        return (
            <Fragment>
                <div className={styles.banner}>
                    <div className={styles.bannertitle}>{BANNER_LINE1}</div>
                    <div className={styles.bannertext}>{BANNER_LINE2}</div>
                    <div className={styles.muted}>{VERSION}</div>
                </div>
                <div className={styles.list}>
                    {MENU_ITEMS.map(function (it, i) {
                        var active = i === self.state.menuIdx;
                        return (
                            <button key={it.id} type="button"
                                    className={[styles.row, active ? styles.active : ''].join(' ')}
                                    onMouseEnter={function () { self.hoverMenu(i); }}
                                    onClick={function () { self.pickMenu(i); }}>
                                <span className={styles.cursor}>{active ? '> ' : '  '}</span>
                                <span className={styles.label}>{it.id}</span>
                                <span className={styles.muted}>- {it.desc}</span>
                            </button>
                        );
                    })}
                </div>
            </Fragment>
        )
    }

    renderWhoami() {
        return (
            <Fragment>
                {this.sectionTitle('whoami')}
                {WHOAMI_PARAGRAPHS.map(function (p, i) {
                    return <p className={styles.para} key={i}>{p}</p>;
                })}
            </Fragment>
        )
    }

    renderWork() {
        return (
            <Fragment>
                <div className={styles.cmdheader}>$ work --history</div>
                {WORK_ROWS.map(function (r, i) {
                    return (
                        <div className={styles.workrow} key={i}>
                            <span className={[styles.muted, styles.wyears].join(' ')}>{r.years}</span>
                            <span className={[styles.label, styles.wcompany].join(' ')}>{r.company}</span>
                            <span className={[styles.muted, styles.wplace].join(' ')}>{r.place}</span>
                            <span className={styles.wline}>{r.line}</span>
                        </div>
                    );
                })}
            </Fragment>
        )
    }

    renderProjects() {
        var self = this;
        return (
            <Fragment>
                <div className={styles.cmdheader}>$ projects --all</div>
                <div className={styles.list}>
                    {PROJECTS.map(function (p, i) {
                        var active = i === self.state.projIdx;
                        return (
                            <button key={p.title} type="button"
                                    className={[styles.row, active ? styles.active : ''].join(' ')}
                                    onMouseEnter={function () { self.hoverProject(i); }}
                                    onClick={function () { self.pickProject(i); }}>
                                <span className={styles.cursor}>{active ? '> ' : '  '}</span>
                                <span>{p.title}</span>
                                {p.badge ? self.badge(p) : null}
                            </button>
                        );
                    })}
                </div>
            </Fragment>
        )
    }

    badge(p) {
        var cls = p.badgeKind === 'collab' ? styles.badgecollab : styles.badgenow;
        return <span className={[styles.badge, cls].join(' ')}>{p.badge}</span>;
    }

    renderDetail() {
        var p = PROJECTS[this.state.projIdx];
        return (
            <Fragment>
                <div className={styles.title}>
                    <span className={styles.cursor}>&gt; </span>
                    <span className={styles.titletext}>{p.title}</span>
                    {p.badge ? this.badge(p) : null}
                </div>
                {p.paragraphs.map(function (t, i) {
                    return <p className={styles.para} key={i}>{t}</p>;
                })}
                {p.mock === 'recs' ? this.renderRecs() : null}
                {p.mock === 'airflow' ? this.renderAirflow() : null}
                <div className={styles.links}>
                    {p.links.map(function (l, i) {
                        return (
                            <div key={i}>
                                <span className={styles.muted}>{l.label}: </span>
                                <a className={styles.link} href={'https://' + l.url}
                                   target="_blank" rel="noopener noreferrer">{l.url}</a>
                            </div>
                        );
                    })}
                </div>
            </Fragment>
        )
    }

    renderRecs() {
        return (
            <div className={styles.mock}>
                <div className={styles.cmdheader}>$ recs --user u_4f2a</div>
                {RECS.map(function (r, i) {
                    return (
                        <div key={i}>
                            <span className={styles.mockname}>{r.name}</span>
                            <span className={styles.ok}>{r.score}</span>
                        </div>
                    );
                })}
            </div>
        )
    }

    renderAirflow() {
        return (
            <div className={styles.mock}>
                <div className={styles.cmdheader}>$ airflow dags list</div>
                {DAGS.map(function (d, i) {
                    var cls = d.kind === 'ok' ? styles.ok : d.kind === 'run' ? styles.run : styles.muted;
                    return (
                        <div key={i}>
                            <span className={styles.mocknamewide}>{d.name}</span>
                            <span className={[styles.mockstate, cls].join(' ')}>{d.mark} {d.state}</span>
                            <span className={styles.muted}>{d.time}</span>
                        </div>
                    );
                })}
            </div>
        )
    }

    renderPosts() {
        return (
            <Fragment>
                {this.sectionTitle('posts')}
                {POSTS.map(function (p, i) {
                    return (
                        <div className={styles.post} key={i}>
                            <div>{p.title}</div>
                            <a className={styles.link} href={p.url}
                               target="_blank" rel="noopener noreferrer">{p.url}</a>
                        </div>
                    );
                })}
                <div>
                    <span className={styles.muted}>all posts: </span>
                    <a className={styles.link} href="https://trapeznikov.com/posts"
                       target="_blank" rel="noopener noreferrer">trapeznikov.com/posts</a>
                </div>
            </Fragment>
        )
    }

    renderContact() {
        return (
            <Fragment>
                {this.sectionTitle('contact')}
                {CONTACTS.map(function (c, i) {
                    return (
                        <div className={styles.contactrow} key={i}>
                            <span className={styles.cursor}>$ </span>
                            <a className={styles.link} href={c.url}
                               target="_blank" rel="noopener noreferrer">{c.label}</a>
                        </div>
                    );
                })}
            </Fragment>
        )
    }

    sectionTitle(name) {
        return (
            <div className={styles.title}>
                <span className={styles.cursor}>&gt; </span>
                <span className={styles.titletext}>{name}</span>
            </div>
        )
    }
}

export default TerminalModal;
